export const RECEIVE_QUERY_RESULTS = 'RECEIVE_QUERY_RESULTS';
export const IN_FLIGHT = 'IN_FLIGHT';
